@if (brief.publishing()) {
  <atom-loading-overlay title="Publishing your brief" message="This usually takes a few seconds." />
}
@if (brief.step() === 'thinking') {
  <qb-thinking-step />
} @else {
  <div [class]="brief.showSummary() ? 'flex h-full min-h-0 flex-col lg:grid lg:grid-cols-2' : 'flex h-full min-h-0 flex-col'">
    <div class="flex h-full min-h-0 min-w-0 flex-col">
      <header class="sticky top-0 z-10 flex h-14 shrink-0 items-center justify-between gap-3 border-b border-border bg-background px-4 sm:h-16 sm:px-8">
        <div class="flex min-w-0 items-center gap-3">
          @if (brief.showBack()) {
            <button type="button" class="btn-shout-fab-secondary" (click)="brief.goBack()" aria-label="Back">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="size-5" aria-hidden="true">
                <path d="M19 12H5" />
                <path d="m12 19-7-7 7-7" />
              </svg>
            </button>
          }
          <img src="/assets/logos/official/SHOUT_studio_logo_full_colour_black.svg" alt="SHOUT Studio" class="h-7 w-auto dark:hidden" />
          <img src="/assets/logos/official/SHOUT_studio_logo_full_colour_white.svg" alt="" class="hidden h-7 w-auto dark:block" />
        </div>
        @if (brief.progress(); as progress) {
          <p class="m-0 text-base font-bold text-muted-foreground">Step {{ progress.current }} of {{ progress.total }}</p>
        } @else if (brief.step() === 'review') {
          <p class="m-0 whitespace-nowrap rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-primary">Draft · Version {{ brief.version() }}</p>
        }
      </header>

      @if (brief.progress(); as progress) {
        <div class="mt-2.5 flex shrink-0 gap-1 px-4 sm:px-8" aria-hidden="true">
          @for (segment of [1, 2, 3]; track segment) {
            @if (segment <= progress.total) {
              <div class="h-1 flex-1 rounded-sm transition-colors duration-200" [class]="segment <= progress.current ? 'bg-primary' : 'bg-muted'"></div>
            }
          }
        </div>
      }

      <main class="mx-auto flex min-h-0 w-full max-w-3xl flex-1 flex-col overflow-hidden">
        @switch (brief.step()) {
          @case ('focus') { <qb-promoting-step /> }
          @case ('format') { <qb-format-step /> }
          @case ('network') { <qb-network-step /> }
          @case ('review') { <qb-review-step /> }
          @case ('published') { <qb-outcome-step /> }
          @case ('draft') { <qb-outcome-step /> }
        }
      </main>
    </div>
    @if (brief.showSummary()) {
      <qb-summary-panel class="hidden lg:flex" />
    }
  </div>
}
